import { useMemo } from "react";
import type { Attendees, TranscriptRecord } from "../types";

const AttendeesBox = ({ transcriptData }: { transcriptData: TranscriptRecord[] }) => {
  const attendees: Attendees | undefined = useMemo(() => {
    const attendeesItems = transcriptData.filter((item) => item.type === "attendees");

    if (attendeesItems.length === 0) {
      return undefined;
    }
    try {
      if (attendeesItems[0]?.content) {
        return JSON.parse(attendeesItems[0].content) as Attendees;
      }
      return undefined;
    } catch {
      return undefined;
    }
  }, [transcriptData]);

  if (!attendees) {
    return <div>No attendees found.</div>;
  }

  return (
    <div className={`mb-4`}>
      <span className={`fs-3 fw-bold`}>Attendees</span>
      <div className={`fs-standard`}>
        {attendees.Attendees.map((attendee, index) => (
          <span key={index}>
            {attendee.name} {attendee.company && `(${attendee.company})`}
            {index < attendees.Attendees.length - 1 ? ", " : ""}
          </span>
        ))}
      </div>
    </div>
  );
};

export default AttendeesBox;
